<div class="logo-wrapper w-100 h-100 d-flex justify-content-center align-items-center">
  <img src="https://mmicdn.s3.eu-central-1.amazonaws.com/Amber/amber-logo.png" />
</div>
